import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import {
	Button,
	Modal,
	Flex,
	Tooltip
} from 'antd';
import {
	FileSearchOutlined
} from '@ant-design/icons';
import type {
	ICondition,
	IQueryFieldsItem,
	Observer
} from 'src/interfaces/entities/observer';
import {
	CodeEditor,
	QueryDisplay
} from 'src/pages/observers/components';
import { useLazyGetObserverByIdQuery } from 'src/redux/services/centralApi';
import { IQueryResult } from 'src/pages/observers/components/CodeEditor/types';

export default function VisualizeObserver(
	{
		row,
	}: { row: Observer }
) {
	const [ open, setOpen, ] = useState<boolean>(false);
	const [ queryResult, setQueryResult, ] = useState<IQueryResult>();
	const [ queryFields, setQueryFields, ] = useState<IQueryFieldsItem[]>([]);
	const [ conditions, ] = useState<Record<string, ICondition>>(row.conditions ?? {});

	const [
		getObserverData,
		observerDataResult,
	] = useLazyGetObserverByIdQuery();

	useEffect(() => {
		if (open) {
			const id = row.observer_id;
			getObserverData({ id, });
		}
	}, [ open, row, ]);

	return <>
		<Tooltip title="Visualizar dados">
			<Button
				type="text"
				icon={<FileSearchOutlined />}
				onClick={() => setOpen(true)}
			/>
		</Tooltip>
		<Modal
			width={1000}
			centered
			title={'Visualizar dados do observador'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			footer={(_, { OkBtn, CancelBtn, }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			)}
		>
			<Flex vertical gap={16}>
				<div>
					<CodeEditor
						conditions={conditions}
						readOnly
						growWithCode
						editor_props={{
							value: observerDataResult.data?.module_sql || observerDataResult.data?.sql || '',
						}}
						height='513px'
						executable
						hasReturn={Boolean(queryResult)}
						onQueryResultChange={(value) =>
							setQueryResult(value)
						}
						onQueryFieldsChange={(value) => {
							setQueryFields(value);
						}}
					/>
					{
						(queryFields && queryResult) &&
						<QueryDisplay
							queryResult={queryResult}
							queryFields={queryFields}
						/>
					}

				</div>
			</Flex>		
		</Modal >
	</>;
}